import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type {
  ConversationDetailTab,
  ConversationTraceAvailability,
  ConversationVerdict,
} from "@/features/conversations/conversations-data";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ConversationExplorerPage } from "@/features/conversations";
import {
  CONVERSATION_DETAIL_TAB,
  CONVERSATION_TRACE_AVAILABILITY,
  CONVERSATION_VERDICT,
} from "@/features/conversations/conversations-data";

const VERDICT_VALUES = Object.values(CONVERSATION_VERDICT) as [
  ConversationVerdict,
  ...ConversationVerdict[],
];
const TRACE_VALUES = Object.values(CONVERSATION_TRACE_AVAILABILITY) as [
  ConversationTraceAvailability,
  ...ConversationTraceAvailability[],
];
const TAB_VALUES = Object.values(CONVERSATION_DETAIL_TAB) as [
  ConversationDetailTab,
  ...ConversationDetailTab[],
];

const conversationSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  application: z.string().optional().catch(undefined),
  verdict: z.enum(VERDICT_VALUES).optional().catch(undefined),
  trace: z.enum(TRACE_VALUES).optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
  limit: z.coerce.number().int().min(1).max(100).optional().catch(undefined),
  conversationId: z.string().optional().catch(undefined),
  tab: z.enum(TAB_VALUES).optional().catch(undefined),
});

export const Route = createFileRoute("/conversations/")({
  component: () => (
    <PermissionGuard module="conversations">
      <ConversationExplorerPage />
    </PermissionGuard>
  ),
  validateSearch: conversationSearchSchema,
});
